"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveElement = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "getActiveElement", { enumerable: true, get: function () { return dom_utilities_1.getActiveElement; } });
//# sourceMappingURL=getActiveElement.js.map